import { http } from "@/utils/http";
import { ResponseResult } from "./common";

export const fetchAsyncRoutes = () => {
  return http.request<ResponseResult<Array<any>>>("get", "/menu/tree");
};
